import { createRouter, createWebHistory } from 'vue-router'
import HelloWorld from './components/HelloWorld.vue'
import ToolsPage from './components/ToolsPage.vue'

const routes = [
  { path: '/', component: HelloWorld },
  { path: '/tools', component: ToolsPage }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    // Remove all manual scroll logic and use only Vue Router's recommended API
    return { top: 0 };
  },
})

export default router
